import {Vue} from 'vue-property-decorator';
import {GenericTableSelectMode} from '../GenericTableSelectMode';
import {IRow} from '../GenericTableRow';

/** Strategie pour un "GenericTable" avec une selection simple */
export class GenericTableModeSimpleSelect extends GenericTableSelectMode {

    /** Ligne selectionnée sur selection simple */
    private currentRowSelected: IRow = undefined;

    /** Application concrète de l'initialisation des paramètre pour "selection simple" */
    public Initialize(): void {
        Vue.set(this.context, 'EnableToggleSelectionAll', false);
        Vue.set(this.context, 'EnableMenuLeft', true);
        Vue.set(this.context, 'EnableSelectorCheckBox', false);
        Vue.set(this.context, 'EnableSelectorRow', true);
        Vue.set(this.context, 'ShowSelectedCount', false);
    }

    /**
     * Permute l'état de selection de toute les lignes
     * @param row Lignes dont l’état de sélection doit être inversé
     */
    public ToggleRow(row: IRow, displayedRows: boolean): void {
        /** Si selection vérouillé alors on annule le toggle */
        if (row.IsLockedSelect) {
            return;
        }

        const isRowCurrentlySelected = this.currentRowSelected && this.currentRowSelected.Id === row.Id;

        // Si la ligne est déjà la ligne sélectionnée (clic pour désélectionner).
        if (isRowCurrentlySelected) {
            // Désélectionner la ligne actuelle.
            Vue.set(row, 'Selected', false);
            Vue.set(this, 'currentRowSelected', undefined);
        } else {
            // Purger les tableaux de sélection pour n'autoriser qu'une seule sélection.
            this.context.SelectedRows.length = 0;
            this.context.SelectedDisplayedRows.length = 0;

            // Si une autre ligne était sélectionnée, désélectionner-la.
            if (this.currentRowSelected) {
                Vue.set(this.currentRowSelected, 'Selected', false);
            }

            // Sélectionner la nouvelle ligne.
            this.context.SelectedRows.push(row);
            if (displayedRows) {
                this.context.SelectedDisplayedRows.push(row);
            }
            Vue.set(row, 'Selected', true);
            Vue.set(this, 'currentRowSelected', row);
        }
    }

    /**
     * Permute l'état de selection de toute les lignes
     * @param rows Liste des lignes dont l’état de sélection doit être inversé
     */
    public ToggleRows(): void {
    }

    /**
     * Permute l'état de selection de toute les lignes affichés sur la page en cours
     * @param rows Liste des lignes dont l’état de sélection doit être inversé
     */
    public ToggleDisplayedRows(): void {
    }
}